import { render, staticRenderFns } from "./TemplateFolderBrowserModal.vue?vue&type=template&id=3f0e3645&scoped=true"
import script from "./TemplateFolderBrowserModal.vue?vue&type=script&lang=js"
export * from "./TemplateFolderBrowserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0e3645",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f0e3645')) {
      api.createRecord('3f0e3645', component.options)
    } else {
      api.reload('3f0e3645', component.options)
    }
    module.hot.accept("./TemplateFolderBrowserModal.vue?vue&type=template&id=3f0e3645&scoped=true", function () {
      api.rerender('3f0e3645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/TemplateFolderBrowserModal.vue"
export default component.exports